"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    courseList: [Array],
    view: [String]
  },
  data: function data() {
    return {
      // eslint-disable-next-line no-undef
      img202: require("@/assets/img/user.png")
      // courseList: [
      //   {
      //     teacherName: "摩拉克斯",
      //     name: "新时代的第一次测试文档",
      //     schoolName: "杭州工艺美术学校",
      //     pointLike:false
      //   },
      //   {
      //     teacherName: "测试教师",
      //     name: "测试名称",
      //     schoolName: "杭州工艺美术学校",
      //     pointLike:false
      //   }
      // ]
    };
  },
  methods: {
    lookDetails: function lookDetails(e) {
      if (e) {
        window.open(e);
      } else {
        return null;
      }
    },
    iLikeIt: function iLikeIt(e) {
      e.pointLike = !e.pointLike;
    }
  },
  created: function created() {}
};